/* eslint-disable @typescript-eslint/default-param-last */
import { ActionType } from '../../types/Interviews/interviews.types';
import { GET_CANDIDATES } from '../../constants/ActionTypes';
import initialState from '../../store/initialState';

/**
 * Job Roles Reducer
 * @param {IInterviews} state=initialState.jobRoles
 * @param {ActionType} action:ActionType
 * @returns {void}
 */
const candidatesReducer = (
  state = initialState.candidates,
  action: ActionType
) => {
  switch (action?.type) {
    case `${GET_CANDIDATES}_SUCCESS`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default candidatesReducer;
